<template>
  <section class="partners-section" :class="ready ? 'render-ready' : 'render-locked'">
    <h2 class="section-title">Our Partners</h2>
    <div ref="partnerSwiper" class="swiper-container partner-swiper">
      <div class="swiper-wrapper">
        <div v-for="(partner, idx) in partners" :key="idx" class="swiper-slide partner-slide">
          <img :src="partner.url" :alt="'Partner'" class="partner-logo" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Swiper from 'swiper'
import { fetchHomeData } from '@/api'

export default {
  name: 'Partners',
  data() { return { partners: [], ready: false, partnerSwiper: null } },
  async mounted() {
    const data = await fetchHomeData()
    this.partners = data.partners
    await this.$nextTick()
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.partnerSwiper = new Swiper(this.$refs.partnerSwiper, {
          slidesPerView: 'auto', spaceBetween: 12,
          freeMode: true, loop: true,
          autoplay: { delay: 0, disableOnInteraction: false },
          speed: 3000,
          observer: true, observeParents: true,
        })
        this.ready = true
      })
    })
  }
}
</script>

<style scoped>
.partners-section { padding: var(--s-6) 0; background: var(--bg-page); }
.section-title { color: var(--text-dim); font-size: var(--font-size-xs); font-weight: 500; text-transform: uppercase; letter-spacing: 2px; text-align: center; margin-bottom: var(--s-4); padding: 0 var(--s-5); }
.partner-swiper { width: 100%; overflow: hidden; }
.partner-swiper .swiper-wrapper { display: flex; align-items: center; }
.partner-swiper .swiper-slide { width: auto; flex-shrink: 0; }
.partner-slide { display: flex; align-items: center; justify-content: center; width: 90px; height: 50px; background: rgba(255,255,255,0.05); border-radius: var(--radius-md); padding: var(--s-2); }
.partner-slide:first-child { margin-left: var(--s-5); }
.partner-logo { max-width: 100%; max-height: 100%; object-fit: contain; filter: grayscale(100%) brightness(0.8); opacity: 0.6; transition: all var(--duration-normal); }
.partner-slide:hover .partner-logo { filter: grayscale(0%); opacity: 1; }

/* Harvested pseudo-element decorations (from klakna.sbs) */
.partners-section::before {
  content: '';
  position: absolute;
  top: 0; left: 0; right: 0;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.06), transparent);
  pointer-events: none;
}
.partners-section::after {
  content: '';
  position: absolute;
  bottom: 0; left: 0; right: 0;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.04), transparent);
  pointer-events: none;
}
</style>
